import { hasUnresolvedAssistant } from './hasUnresolvedAssistant'

export function shouldFetchThreadMessages(id, messages, loadedMessages) {
  if (!id) return { fetch: false, unresolved: false }
  const unresolved = hasUnresolvedAssistant(messages ?? [])
  if (unresolved) return { fetch: true, unresolved: true }
  if (loadedMessages.has(id)) return { fetch: false, unresolved: false }
  return { fetch: true, unresolved: false }
}
